import { render, staticRenderFns } from "./AutoSubscription.vue?vue&type=template&id=9daca5c0"
import script from "./AutoSubscription.vue?vue&type=script&lang=ts"
export * from "./AutoSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports